//TODO:add font to the typography parts

export const paperContent = {
  justifyContent: "center",
  alignItems: "center",
  height: "102px",
  width: "100%",
  marginTop: "12px",
};

export const SummaryItemCardStyle = {
  padding: "24px 26px",
  display: "flex",
  width: "100%",
};

export const SummaryCardHeading = {
  fontFeatureSettings: "case on",
  textTransform: "none",
  fontSize: "15px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "-0.24px",
};

export const SummaryCardAmountText = {
  fontFeatureSettings: "case on",
  textTransform: "none",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "34px",
  letterSpacing: "0.36px",
};

export const SummaryCardDesciption = {
  fontFeatureSettings: "case on",
  textTransform: "none",
  fontSize: "8px",
  fontStyle: "normal",
  fontWeight: "300",
  lineHeight: "13px",
  letterSpacing: "0.066px",
};
